/**
 * LanguageInfoBlock component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled language info block.
 */
const LanguageInfoBlock = styled.div`
  display: block;
  margin-bottom: ${24 * Screen.widthRatio}px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export default LanguageInfoBlock;
